webpackJsonp([70144966829960],{

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Headers = __webpack_require__(46);
	
	var _typography = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var container = {
	  margin: '0 auto',
	  maxWidth: 960,
	  padding: (0, _typography.rhythm)(1) + ' ' + (0, _typography.rhythm)(3 / 4),
	  paddingTop: 0
	};
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { style: container },
	      _react2.default.createElement(
	        'div',
	        { className: 'mobile-h1' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Contact'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          _Headers.Header2,
	          { color: '#161f4b' },
	          'Contact Quality Link Consulting'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'section',
	            { className: 'seven columns' },
	            _react2.default.createElement(
	              _Headers.Header3,
	              { color: '#3348b1' },
	              'Our Address'
	            ),
	            _react2.default.createElement(
	              'address',
	              null,
	              _react2.default.createElement('span', { className: 'fa fa-map-marker' }),
	              ' 4445 Eastgate Mall, Suite 200',
	              _react2.default.createElement('br', null),
	              'San Diego, CA 92121',
	              _react2.default.createElement('br', null),
	              'USA',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'a',
	                { href: 'tel://+6197191604' },
	                _react2.default.createElement('span', { className: 'fa fa-phone' }),
	                ' 1-619-719-1604'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:info@qualitylinkconsulting.com?SUBJECT=Website-information' },
	                _react2.default.createElement('span', { className: 'fa fa-envelope-o' }),
	                ' info@qualitylinkconsulting.com'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'five columns' },
	            _react2.default.createElement(
	              'form',
	              { name: 'contact', method: 'post', action: '/thanks/', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field' },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'legend',
	                  null,
	                  _react2.default.createElement(
	                    _Headers.Header3,
	                    { color: '#3348b1' },
	                    'WRITE US'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	                _react2.default.createElement(
	                  'p',
	                  { hidden: true },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Don\u2019t fill this out: ',
	                    _react2.default.createElement('input', { name: 'bot-field' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'name', className: 'field-type' },
	                  'Your Name:'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'name',
	                  name: 'clientname',
	                  placeholder: ' enter your name',
	                  maxLength: '30',
	                  autoFocus: true,
	                  required: true
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'email', className: 'field-type' },
	                  'Your Email:'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'email',
	                  id: 'email',
	                  name: 'clientemail',
	                  placeholder: ' enter your email',
	                  maxLength: '50',
	                  pattern: '^([a-z0-9_\\.-]+)@([\\da-z\\.-]+)\\.([a-z\\.]{2,6})$',
	                  required: true
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'tel', className: 'field-type' },
	                  'Your Phone Number:'
	                ),
	                _react2.default.createElement('input', { type: 'tel', id: 'tel', name: 'clienttel', title: '123-333-4444', maxLength: '12' }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Subject:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { name: 'subject', required: true },
	                  _react2.default.createElement('option', null),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Inquire about consulting' },
	                    'Inquire about consulting'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Find out about training' },
	                    'Find out about training'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'Schedule a call' },
	                    'Schedule a call'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'General Information' },
	                    'General Information'
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'comment', className: 'field-type' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Describe what we can help you with:'
	                  )
	                ),
	                _react2.default.createElement('textarea', { id: 'comment', name: 'comment' }),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-default', type: 'submit', name: 'submit-contact-form' },
	                  'Send Message'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-2b968739e5d75ee8d8c6.js